import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { I18nProvider } from "@/i18n/I18nProvider";
import { SettingsProvider } from "@/context/SettingsContext";
import { Layout } from "@/components/layout/Layout";
import Home from "@/pages/Home";
import { StaticPage } from "@/pages/StaticPage";
import { LegalPage } from "@/pages/LegalPage";
import Committees from "@/pages/Committees";
import Districts from "@/pages/Districts";
import { Resources, Downloads } from "@/pages/Resources";
import Faq from "@/pages/Faq";
import { News, Events, Media } from "@/pages/Newsroom";
import Verify from "@/pages/Verify";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";

const STATIC_ROUTES = [
  { path: "/about", key: "about", seo: "About GPU — Pharmaceutical Trade Association Gujarat" },
  { path: "/objectives", key: "objectives" },
  { path: "/membership", key: "membership", cta: "member", seo: "GPU Membership — Pharma Wholesaler Association Gujarat" },
  { path: "/member-benefits", key: "memberBenefits", cta: "member" },
  { path: "/member-registration", key: "memberRegistration", cta: "member" },
  { path: "/membership-declaration", key: "declaration", cta: "member" },
  { path: "/vendor-network", key: "vendorNetwork", cta: "vendor", seo: "GPU Vendor Network — Pharma Vendor Gujarat" },
  { path: "/vendor-registration", key: "vendorRegistration", cta: "vendor" },
  { path: "/gpu-protection", key: "protection" },
  { path: "/safe-trade-network", key: "safeTrade", seo: "Safe Trade Network — Pharmaceutical Distributor Network Gujarat" },
  { path: "/anti-counterfeit", key: "antiCounterfeit" },
  { path: "/institutional-engagement", key: "institutional" },
  { path: "/code-of-ethics", key: "ethics" },
];

function App() {
  return (
    <I18nProvider>
      <SettingsProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              {STATIC_ROUTES.map((r) => (
                <Route
                  key={r.path}
                  path={r.path}
                  element={<StaticPage pageKey={r.key} path={r.path} seoTitle={r.seo} ctaVariant={r.cta || "both"} />}
                />
              ))}
              <Route path="/committees" element={<Committees />} />
              <Route path="/districts" element={<Districts />} />
              <Route path="/resources" element={<Resources />} />
              <Route path="/downloads" element={<Downloads />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/news" element={<News />} />
              <Route path="/events" element={<Events />} />
              <Route path="/media" element={<Media />} />
              <Route path="/verify" element={<Verify />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy" element={<LegalPage pageKey="privacy" path="/privacy" />} />
              <Route path="/terms" element={<LegalPage pageKey="terms" path="/terms" />} />
              <Route path="/disclaimer" element={<LegalPage pageKey="disclaimer" path="/disclaimer" />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" richColors closeButton />
      </SettingsProvider>
    </I18nProvider>
  );
}

export default App;
